import { Header } from '@components/summary/header/header';
import { ProcessSummary } from '@components/summary/process-summary/process-summary';
import './summary-page.scss';
import { EmailInput } from '@components/email-input/email-input';
import { ApplicantDocumentConsent } from '@components/summary/applicant-document-consent/applicant-document-consent';
import {
    useAccountApplicationActions,
    useSelectedChildEligibility,
} from '@hooks/context/use-account-application-context';
import { useNavigateHomeIfNoChildSelected } from '@hooks/navigation/use-navigation-effects';

export const SummaryPage = () => {
    const selectedChildEligibility = useSelectedChildEligibility();
    const { setApplicantParentEmail } = useAccountApplicationActions();

    useNavigateHomeIfNoChildSelected();

    if (!selectedChildEligibility) {
        return null;
    }

    return (
        <div className="summary-container">
            <Header />
            <ProcessSummary childEligibility={selectedChildEligibility} />
            <EmailInput setValue={setApplicantParentEmail} />
            <ApplicantDocumentConsent />
        </div>
    );
};
